import api from "../services/api";

const path = "tipopontoacesso";

export const getTypesPointAccess = async () => {
  return await api.get(`${path}`);
};

export const findTypePointAccess = async ({ id }) => {
  return await api.get(`${path}/${id}`);
};

export const editTypePointAccess = async ({ id, body }) => {
  return await api.put(`${path}/${id}`, body);
};

export const createTypePointAccess = async ({ body }) => {
  return await api.post(`${path}`, body);
};

export const deleteTypePointAccess = async ({ id }) => {
  return await api.delete(`${path}/${id}`);
};
